// extracted by mini-css-extract-plugin
export var actions = "_12-0";
export var actionsContainer = "_12-6";
export var border = "_12-1";
export var childFullHeight = "_12-d";
export var collapse = "_12-2";
export var content = "_12-8";
export var contentChild = "_12-c";
export var fullscreen = "_12-a";
export var headerContainer = "_12-3";
export var headerRow = "_12-5";
export var hidePadding = "_12-9";
export var noScrollX = "_12-e";
export var noScrollY = "_12-f";
export var optOutTopPadding = "_12-b";
export var pagePadding = "_12-7";
export var profile = "_12-g";
export var profileContainer = "_12-h";
export var profileImage = "_12-i";
export var profileMain = "_12-j";
export var profileSubtitle = "_12-l";
export var profileTitle = "_12-k";
export var tabsWrapper = "_12-4";
export var title = "_12-m";